/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterI = createReactComponent("letter-i", "IconLetterI", [
  ["path", { d: "M12 4l0 16", key: "svg-0" }]
]);

export { IconLetterI as default };
//# sourceMappingURL=IconLetterI.js.map
